import {Component} from 'react';
import PropTypes from 'prop-types';
import './generated/styleguide/semantic.css';
import UnexpectedErrorDialog from './components/UnexpectedErrorDialog';

export default class Layout extends Component {
  static propTypes = {
    children: PropTypes.node
  };


  render() {
    const {children} = this.props;
    return (
      <div>
        {children}
        <UnexpectedErrorDialog/>
      </div>
    );
  }
}